// extracted by mini-css-extract-plugin
export default {"root":"rX6Ma_","fixViewMoreFont":"Yl7g1w"};